/**
 * activityBarContext — Shared utility for determining the Activity Bar page context.
 *
 * Used by AppShell (auto-open logic) and ActivityBar (chip/button rendering).
 * Maps route pathnames to context keys defined in config/activityBar/actions.json.
 */

/**
 * Page contexts where the Activity Bar should auto-open by default.
 * Excludes "generic" (settings, admin, other unmatched routes).
 */
export const AUTO_OPEN_CONTEXTS = new Set([
    "patientDetail",
    "patientsList",
    "dashboard",
    "dashboardPatientSelected",
    "documentEditor",
]);

/**
 * Derive the Activity Bar context from the current route pathname.
 *
 * @param {string} pathname     - Current location.pathname
 * @param {string|null} selectedPatientId - Dashboard-selected patient (Clinical Day View)
 * @returns {string} Context key matching actions.json
 */
export function detectContext(pathname, selectedPatientId) {
    if (!pathname) return "generic";
    if (pathname.startsWith("/document")) return "documentEditor";
    if (pathname.startsWith("/patients")) return "patientsList";
    if (pathname.startsWith("/patient")) return "patientDetail";
    if (pathname === "/dashboard" || pathname === "/") {
        return selectedPatientId ? "dashboardPatientSelected" : "dashboard";
    }
    return "generic";
}
